module.exports = __webpack_public_path__ + "img/plumbing-repair-03-tablet.9ab8eb02.jpg";